import $ from 'jquery';
import _escape from 'lodash/escape';

$( document ).on( 'click', '.js-product-card__finish', function ( event ) {
	event.preventDefault();

	const $link = $( this );
	const $li = $link.closest( 'li' );
	const $card = $link.closest( '.js-product-card' );
	const $image = $card.find( '.js-product-card__img' );
	const $tags = $card.find( '.js-product-card__tags' );
	const $sku = $card.find( '.js-product-card__sku' );
	const $price = $card.find( '.js-product-card__price' );

	const variants = $card.data( 'variants' );
	const variant = variants[ $li.index() ];

	$li.siblings( '.is-selected' ).removeClass( 'is-selected' );
	$li.addClass( 'is-selected' );
	$image.attr( 'src', variant.main_image );

	$tags.empty();

	if ( variant.is_obsolete ) {
		$tags.append( '<span class="c-tag c-tag--small">RETIRED</span>' );
	}

	$sku.text( `Model ${variant.sku}` );

	// handle price

	$price.empty();

	if ( variant.price && ! variant.is_obsolete ) {
		$price.append( `
			<p class="c-price__amount">
				<span class="c-price__small c-price__sup">
					${ _escape( variant.price.sign ) }
				</span>
				<span class="c-price__number">
					${ _escape( variant.price.formattedAmmount ) }
				</span>
				<span class="c-price__small">
					${ _escape( variant.price.currency ) }
				</span>
			</p>
		` );
	}

	if ( variant.availabilityHtml ) {
		$price.append( `<div class="c-price__note">${ variant.availabilityHtml }</div>` );
	}
} );
